
import { Component, Vue } from 'vue-property-decorator';
import SnackHub from 'spa-ionata-admin/lib/components/SnackHub.vue';
// import ManifestUpdateChecker from 'spa-ionata-admin/lib/components/ManifestUpdateChecker.vue';
import CacheProvider from 'spa-ionata-admin/lib/components/CacheProvider.vue';
import { isProd } from './config';
import ExtHeader from './components/ExtHeader.vue';
import ExtFooter from './components/ExtFooter.vue';
import { loadLanguageAsync } from './i18n';
import { extNavModule, settingsModule } from './store';
import './styles/styles.scss';

@Component({
  components: {
    ExtHeader,
    ExtFooter,
    SnackHub,
    // ManifestUpdateChecker,
    CacheProvider,
  },
})
export default class App extends Vue {
  loadingLang = true;

  registration: HashAny | undefined = undefined;

  updateExists = false;

  refreshing = false;

  checkManifest = false;

  get isReady() {
    return !this.loadingLang && !extNavModule.isLoading;
  }

  showRefreshUI(event: HashAny) {
    this.registration = event.detail;
    this.updateExists = true;
  }

  refreshApp() {
    this.updateExists = false;
    if (!this.registration || !this.registration.waiting) {
      return;
    }
    // 👇 Send a message to the browser to skip the waiting and activate the new service worker
    this.registration.waiting.postMessage('skipWaiting');
  }

  created() {
    this.checkManifest = isProd;
    if ('serviceWorker' in navigator) {
      // 👇 Listen to custom service worker event to be able to respond to updates
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (document as any).addEventListener('swUpdated', this.showRefreshUI, {
        once: true,
      });

      navigator.serviceWorker.addEventListener('controllerchange', () => {
        if (this.refreshing) return;
        this.refreshing = true;
        // 👇 Force reload the page since we want to have the new service worker updated
        window.location.reload(true);
      });
    }
  }

  async mounted() {
    try {
      await loadLanguageAsync(settingsModule.lang);
    } finally {
      this.loadingLang = false;
    }
  }
}
